module.exports = __webpack_public_path__ + "static/media/5.bdc1f0f6.svg";